import React from 'react';
import GOTUtil from '../../utils/GOTUtil';
import FormLoadHelper from '../../utils/FormLoadHelper';
import Command from '../../remote/Command';
import ServiceHelper from '../../remote/ServiceHelper';
require('./style/ListMainMenuStyle.css');
export default class ListMainMenu extends React.Component{
	constructor(props){
		super(props);
		this.renderMainMenu=this.renderMainMenu.bind(this);
		this.renderSubMenu=this.renderSubMenu.bind(this);
		this.menuItemClick=this.menuItemClick.bind(this);
		this.platMainMenu = {};
	}

	menuItemClick(event)
	{
		var target = event.target;
		var _label = $(target).attr("data-formLabel");
		var _formId = $(target).attr("data-formId");
		var _menuItemId = $(target).attr("data-menuItemId");
		var _onlyQuery=$(target).attr("data-onlyQuery");
		FormLoadHelper.openMenuItem({menuItemId:_menuItemId,onlyQuery:_onlyQuery,label:_label,checkHas:false,fromMainMenu:true});
		//window.testOpenForm(_label,_formId,_menuItemId,_onlyQuery);
	}

	getLabelName(item){
		var label=GOTUtil.getPropertyValue(item,"Label");
      	if(label==""|!label){
      		label=item.name;
      	}
      	return label;
	}

	renderMainMenu(menuData,moudleId)
	{
		const content=[];
		if(menuData){
			for(var i=0;i<menuData.length;i++){
				var item=menuData[i];
				
				var isShow=false;
				var visible=item.Properties.Visible.V;
      			if(visible!='false'){
      				if(window.userInfos.isAdmin){
	      				isShow=true;
	      			}else{
	      				moudleId=item.id; 
	      				var authorityArr=window.xmlType0SCache[moudleId];
	      				if(authorityArr!=undefined){
	      					if(authorityArr.del){
	      						isShow=true;
	      					}
	      				}
	      			}
      			}
      			
				
	      		
	      		if(isShow){
					var label=this.getLabelName(item);
					var _subMenu = this.renderSubMenu(item.items,moudleId);
					content.push(<li className='dropdown' key={'dropdown-li'+i}>
										<a className="dropdown-joily-title" key={'dropdown-a'+i}>
											{label}
										</a>
										<ul className='dropdown-content' key={'dropdown-ul'+i}>
											{_subMenu}
										</ul>
								</li>
					);
				}
			}
		return content;
		}
	}

	renderSubMenu(subMenu,moudleId){
		const content=[];
		if(subMenu){
			for(var i=0;i<subMenu.length;i++){
				var item=subMenu[i];
				if(item.qname=="MenuSub")
				{
					var isShow=false; 
					var visible=item.Properties.Visible.V;
      				if(visible!='false'){
      					if(window.userInfos.isAdmin){
	      					isShow=true;
	      				}else{
	      					var thisAu=moudleId+'.'+item.id;
	      					var authorityArr=window.xmlType1SCache[thisAu];
	      					if(authorityArr!=undefined){
	      						if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	      							isShow=false;
	      						}else{
	      							isShow=true;	
	      						}
	      					}
	      				}
      				}
      				
					
      				
      				if(isShow){
						var label=this.getLabelName(item);
						var _subMenu = this.renderSubMenu(item.items,moudleId);
						var _caretRightDisplay = "block";
						if(!_subMenu || _subMenu.length==0)
							_caretRightDisplay = "none";
						content.push(<li className='dropdown-joily' key={'joily'+i}>
										<a className="dropdown-joily-title" href="#">{label}</a>
										<i className="fa fa-caret-right" ></i>
										<ul className='dropdown-content-joily' key={'joily-ul'+i}>
											{_subMenu}
										</ul>
									</li>
						);
					}
      				
					
				}
				else if(item.qname=='MenuItem')
				{
					
					var isShow=false;   
      				var onlyQuery=false;
      				var visible=item.Properties.Visible.V;
      				if(visible!='false'){
      					if(window.userInfos.isAdmin){
	      					isShow=true;
	      					//onlyQuery=true;
	      				}else{
	      					var thisAu=moudleId+'.'+item.idInMenu;
	      					var authorityArr=window.xmlType1SCache[thisAu];
	      					if(authorityArr){
	      						/*if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	      							isShow=false;
	      							onlyQuery=false;//看不见打不开
	      						}else if(!authorityArr.del&&!authorityArr.query&&authorityArr.visible){
	      							isShow=true;
				      				onlyQuery=false;//看见打不开
				      			}else if((!authorityArr.del&&authorityArr.query&&authorityArr.visible)||(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible)){
				      				isShow=true;
				      				onlyQuery=true;//看见打开 
				      			}else{
				      				isShow=true;
				      				onlyQuery=false;//看见打开
				      			}*/
				      			if(!authorityArr.del && !authorityArr.visible && !authorityArr.query)
								{
									onlyQuery = true;
								}
								else if(!authorityArr.del && authorityArr.query)
								{
									isShow = true;onlyQuery = true;
								}
								else if(authorityArr.del || authorityArr.query)
								{
									isShow = true;
								}
				      		}
				      	}
      				}
      				
      				var label=this.getLabelName(item);
					if(isShow){
						let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid
						content.push(<a href='#' key={i} onClick={this.menuItemClick} data-formId={dataFormId}
										   data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={onlyQuery}>{label}</a>)

						let menuItemKey = item.id+"."+item.idInMenu;
      					item.onlyQuery = onlyQuery;
      					this.platMainMenu[menuItemKey] = item;
					}
					
				}
			}
		}
		return content;
	}

	mouseenterHandler(event)
	{
		var jq = $(event.currentTarget);

		/*if (this.lostTimer) clearTimeout(this.lostTimer);

		$(".listtree-menu li").removeClass("listtree-menu-hover");

		jq.parent().addClass("listtree-menu-hover");*/

		//top
		
		var ul = jq.parent().find(">ul");
		if (!ul || ul.length==0) return;

		//ul.css("top", "-40px");

		var viewHeight = $(window).height() - 1;
		var offset = ul.offset(),
			height = ul.outerHeight();

		var top = offset.top;

		if (top + height > viewHeight) 
		{
			if(height>viewHeight)
			{
				ul.css("top",(0-top)+'px');
				ul.css("height",(viewHeight - 10)+'px');
				ul.mCustomScrollbar({ autoHideScrollbar: true });
			}
			else
			{
				top = viewHeight - (height+top);
				ul.css("top",top+'px')
			}
			
				
		}
	}

	/*mouseleaveHandler(event)
	{
		var jq = $(event.currentTarget);

		this.lostTimer = setTimeout(function () {
			jq.parent().removeClass("listtree-menu-hover");
		}, 200);
	}*/

	componentDidMount()
	{
		$(document.body).on("mouseenter", ".dropdown-joily-title", this.mouseenterHandler.bind(this));
		//$(document.body).on("mouseleave", ".dropdown-joily-title", this.mouseleaveHandler.bind(this));
	}

	renderCustomMenu(mainContent)
	{
		if(!window.userSettingEntryOrig.menuCustomObject)
			return;
		let i = mainContent.length;
		if(i==0)
			return;
		let _menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
		let num = 0;
		for(let key in _menuCustomObject.customItems)
		{
			num++;
		}
		if(num == 0)return;
		mainContent.push(
			
			<li className='dropdown' key={'dropdown-li'+i}>
					<a className="dropdown-joily-title" key={'dropdown-a'+i}>
						常用菜单
					</a>
					<ul className='dropdown-content' key={'dropdown-ul'+i}>
						{this.renderCustomMenuSub()}
					</ul>
			</li>
      	);
	}
	

	renderCustomMenuSubSub(groupKey,groupItem)
	{
		let content = [];let i = 0;
		if(!groupKey)
			return content;
		for(let key in window.userSettingEntryOrig.menuCustomObject.customItems)
		{
			let customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
			if(customItem.groupId != groupKey)
				continue;
			if(this.platMainMenu.hasOwnProperty(key))
			{
				let item = this.platMainMenu[key];
				var label=this.getLabelName(item);
				let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
				content.push(
					<a href='#' key={i} onClick={this.menuItemClick} data-formId={dataFormId}
					   data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>{label}</a>
				);
				i++;
			}
		}
		return content;
	}

	renderCustomMenuSub()
	{
		let content = [];let i = 0;
		for(let groupKey in window.userSettingEntryOrig.menuCustomObject.groups)
		{
			var groupItem = window.userSettingEntryOrig.menuCustomObject.groups[groupKey];
			var label=groupItem.name;
			var _subMenu = this.renderCustomMenuSubSub(groupKey,groupItem);
			var stylClass="drpdown-blockStyle"
			if(!_subMenu || _subMenu.length==0)
					stylClass= "drpdown-noneStyle";
			content.push(
				<li className='dropdown-joily' key={'joily'+i}>
					<a className="dropdown-joily-title" href="#">{label}</a>
					<i  className={"fa fa-caret-right "+stylClass} ></i>
					<ul className='dropdown-content-joily' key={'joily-ul'+i}>
						{_subMenu}
					</ul>
				</li>
			);
			i++;
		}


		for(let key in window.userSettingEntryOrig.menuCustomObject.customItems)
		{
			let customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
			if(customItem.groupId)continue;
			if(this.platMainMenu.hasOwnProperty(key))
			{
				let item = this.platMainMenu[key];
				var label=this.getLabelName(item);
				let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid
				content.push(
					<a href='#' key={i} onClick={this.menuItemClick} data-formId={dataFormId}
					   data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>{label}</a>
				);
				i++;
			}
		}
		return content;
	}



	rederUserDataSettings(mainContent){
		if (window.rightSidebarClicked)return;
		let i = mainContent.length;
		if(i==0)return;
			

		mainContent.push(
			
		<li className='dropdown' key={'dropdown-li'+i}>
				<a className="dropdown-joily-title" key={'dropdown-a'+i}>
					可用导出
				</a>
				<ul className='dropdown-content' key={'dropdown-ul'+i}>
					{this.renderUserDataSettingsSub()}
				</ul>
		</li>
	  );
	}

	renderUserDataSettingsSub(){
		let content = [];let i = 0;
	
	  var command = Command.createService(
		"gongqi.erp.gotmodel.services.UserSettingService",
		"loadUserDataSetSetting",
		"String"
	  );
	  var _resultHandler = function (data) {
	
		let dataSettings = data.result;
		if (!dataSettings) {
		  return;
		}
		dataSettings = JSON.parse(dataSettings);
	
		/**
		 * <li>
			  <a href="javascript:void(0)" style="padding-top: 0px;">
				<h6 class="control-sidebar-heading" style="font-size:14px;cursor:pointer;margin-top: 0px;">9点前打卡次数</h6>
			  </a>
		   </li>
		*/
		window.userDataSettings = dataSettings;
		for (let i = 0; i < dataSettings.length; i++) {
		  let ds = dataSettings[i];

		  content.push(
			  <a href='#' key={i} onClick={window.dataSettingClick} dataSetId={ds.dataSetId}
				  menuLabel={ds.menuLabel} dataSetUniqueId={ds.recId} >{ds.menuLabel}</a>
		  );
		}
			window.rightSidebarClicked = true;
		}
		var remoteArg = {
			command: command, resultFunction: _resultHandler,
			faultFunction: function () { },
			sync: false
		  };
		  ServiceHelper.addTokenWithCommand(remoteArg);
		return content;
	}

	render()
	{
		const menuData=this.props.data.items;
		var moudleId;
		let MainMenu=this.renderMainMenu(menuData,moudleId);
		this.renderCustomMenu(MainMenu);
		//this.rederUserDataSettings(MainMenu);
		return(
			<ul>
        		{MainMenu}
        	</ul>
		);
	}
	
}




// WEBPACK FOOTER //
// ./src/components/menu/ListMainMenu.js